import type { Article } from "@shopify/hydrogen/storefront-api-types";
import { ArrowIcon } from "@components/atoms/Icons/index";
import { Link } from "@shopify/hydrogen";
import { translate } from "@locales";

interface Props {
  blog: Article;
  tag: string;
  closeSearch?: () => void;
}

export function Blog({ blog, tag, closeSearch }: Props) {
  return (
    <Link
      to={blog.handle}
      onClick={closeSearch}
      className="flex border border-custom-gray-50 w-[365px] min-w-[365px] h-[100px]"
    >
      <img className="object-cover w-[100px] h-full" src={blog.image?.url} />
      <div className="p-4 flex flex-col justify-between">
        <h1 className="font-chivo-bold uppercase text-lg leading-none">
          {blog.title}
        </h1>
        <Link
          to={blog.handle}
          className="flex items-center justify-start gap-x-1 w-min"
          onClick={closeSearch}
        >
          <span className="uppercase text-custom-blue text-sm leading-none whitespace-nowrap">
            {translate("base.read-more")}
          </span>
          <ArrowIcon width={20} height={15} fill="#2991C9" />
        </Link>
      </div>
    </Link>
  );
}
